import React from 'react'
import configment from '@adc/configment'
import { UniquePlatformResource } from '@adc/sdk/types'
import { Button } from '../elementals'

interface DownloadLinkProps {
  resource: UniquePlatformResource
  children?: React.ReactNode
  embeddedContext?: string
  variant?: 'anchor' | 'button'
  buttonProps?: React.ComponentProps<typeof Button>
}

export const DownloadLink: React.FC<DownloadLinkProps> = ({
  resource,
  children,
  embeddedContext = 'browser',
  variant = 'anchor',
  buttonProps = {},
}) => {
  const downloadUrl = `${configment.get(
    'RESI_GRAPH_API_URL_EXTERNAL'
  )}/download/${resource.urn}`

  if (variant === 'button') {
    return (
      <Button {...buttonProps} link={downloadUrl}>
        {children ?? 'Download'}
      </Button>
    )
  }

  return (
    <a
      href={downloadUrl}
      rel='noopener noreferrer'
      target={embeddedContext === 'webview' ? '_self' : '_blank'}
      data-elm-id={`download_link_${resource.urn}`}
    >
      {children ?? 'Download'}
    </a>
  )
}

export default DownloadLink
